import React, { useState } from "react"
import { Card, CardHeader } from "reactstrap"
import PlayersTable from "./PlayersTable"
import SpectatePlayersTable from "./SpectatePlayersTable"
import styles from "./Players.module.scss"
import { getSportsConfig } from "../../utility/constants/sportConfig"
import { useSelector } from "react-redux"

const Players = () => {
	const { homeTeam, awayTeam } = useSelector((state) => state.players)

	//* This will only happen if its spectate mode
	if (JSON.parse(localStorage.getItem("spectate" ?? false))) {
		return <SpectatePlayersTable homeTeam={homeTeam} awayTeam={awayTeam} />
	}

	const penaltiesOrEnd = useSelector((state) => state.penaltiesOrEnd)
	const [mvp, setMvp] = useState(
		JSON.parse(localStorage.getItem("mvp") ?? "{}").playerId
	)

	const { hasCaptain, hasBench, hasMvp, formations } = getSportsConfig(
		localStorage.getItem("sport")
	)

	const columns = [{ title: "Broj" }]
	if (formations) {
		columns.push({ title: "Pozicija" })
	}
	columns.push({ title: "Igrač" })
	if (hasCaptain) {
		columns.push({ title: "", key: "kapetan" })
	}

	if (penaltiesOrEnd !== "done" && penaltiesOrEnd !== "forfeit") {
		if (hasBench && penaltiesOrEnd !== "penalties" && penaltiesOrEnd !== "end") {
			columns.push({ title: "Pin", key: "pin" })
		} else if (hasMvp && penaltiesOrEnd === "end") {
			columns.push({ title: "MVP", key: "mvp" })
		}
		columns.push({ title: "", key: "actionBtn" })
	} else {
		columns.pop()
		columns.push({ title: "Kapetan", key: "kapetan" })
	}

	const onSetMvp = (playerId, teamId) => {
		const gameId = JSON.parse(localStorage.getItem("gameDetails")).gameId
		const sport = localStorage.getItem("sport")
		localStorage.setItem(
			"mvp",
			JSON.stringify({ playerId, teamId, gameId, sport })
		)
		setMvp(playerId)
	}

	return (
		<Card>
			<CardHeader>
				<h1 style={{ marginBottom: -4 }}>Tablica igrača</h1>
			</CardHeader>
			<div className={styles.teamName}>
				<h3>{homeTeam?.name}</h3>
				<h3>{awayTeam?.name}</h3>
			</div>
			<div className={styles.tableContainer}>
				<PlayersTable columns={columns} mvp={mvp} setMvp={onSetMvp} />
				<PlayersTable
					columns={columns}
					reverse={true}
					mvp={mvp}
					setMvp={onSetMvp}
				/>
			</div>
		</Card>
	)
}

export default Players
